import { type CMSArrayBase, createCmsUrl } from './base';

export interface ICustomSearchScenario extends CMSArrayBase {
  internal_title?: string; // cms internal_title, not used in code
  gameCategoryId?: string;
  searchKeywords: string;
  showOnSearch: boolean;
  customText: string;
  providerId?: string;
  correctedSearch?: string;
}
export const getCustomSearchScenariosUrl = () =>
  createCmsUrl({
    path: 'search-scenarios',
  });
